module.exports = "../study/imgs/maps/Tokyo/GWQ8/Climate/TemperatureMax/Tokyo_TemperatureMax_MRI_RCP85_End.png";